<template>
  <v-container>
          <!--パンくずリスト-->
    <v-breadcrumbs :items="breadcrumbs">
      <v-breadcrumbs-item
      exact
      slot="item"
      slot-scope="{ item }"
      :to="item.href"
      :disabled="showLink(item.href)">
        {{ item.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <!--全文検索システム内容-->
    <Content></Content>
  </v-container>
</template>

<script>
// 全文検索コンポーネントをインポート
import Content from '../components/Search/Content'

export default {
  name: 'Search',
  components: {
    Content
  }
}
</script>
<script>
import Content from '../components/Search/Content'
export default {
  name: 'Breadcrumbs',
  data: () => ({
    default: {
      name: '',
      href: ''
    },
    // パンくずリスト
    breadcrumbs: [
      {
        name: 'ホーム',
        href: '/'
      },
      {
        name: '製品情報',
        href: '/Products'
      },
     {
        name: '全文検索システム',
        href: 'Search'
      }
    ]
  }),
  methods: {
    // 現在のパス以外はリンクをつけない
    showLink (path) {
      var currentPath = this.$route.path
      if (path === currentPath) {
        return true
      } else {
        return false
      }
    }
  },
  components: {
    Content
  }
}
</script>
